import Radium from 'radium';

/* eslint key-spacing: 0 */

export function combineStyles(...args) {
  const validArgs = args.filter(arg => arg && arg.constructor === Object);
  let ret = {};
  while (validArgs.length > 0) {
    ret = { ...ret, ...validArgs.shift() };
  }
  return ret;
}

const SPIN_KEYFRAME = Radium.keyframes({
  '0%': { transform : 'rotate(0deg)' },
  '100%': { transform : 'rotate(360deg)' },
});

export const SPIN = {
  animation: 'x 650ms linear infinite',
  animationName: SPIN_KEYFRAME,
};

const FADEIN_KEYFRAME = Radium.keyframes({
  '0%': { opacity : 0 },
  '100%': { opacity : 1 },
});

export const FADEIN = {
  opacity: 0,
  animation: 'x 1s ease-in forwards',
  animationName: FADEIN_KEYFRAME,
};

export const QUICK_FADEIN = {
  opacity: 0,
  animation: 'x 650ms ease-in forwards',
  animationName: FADEIN_KEYFRAME,
};

export function square(size) {
  return {
    height: size,
    width: size,
  };
}

export const CORNERS = {
  bottom: 0,
  left: 0,
  right: 0,
  top: 0,
};

export const TRUNCATE = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};


export const COLORS = {
  bg_site        : '#ffffff',
  bg_light       : '#fafafa',
  bg_medium      : '#f6f6f6',
  bg_dark        : '#e6e6e6',

  line_light     : '#dfdfdf',
  line_medium    : '#d3d3d3',
  line_dark      : '#b8b8b8',

  font_white     : '#ffffff',
  font_lightest  : '#bec2c9',
  font_lighter   : '#a0a0a0',
  font_light     : '#7f7f7f',
  font_medium    : '#6d6d6d',
  font_dark      : '#25272c',

  font_grey_light: '#83878c',
  font_grey_dark : '#5d6166',

  brand_xlight   : '#52a7e5',
  brand_lightest : '#4594dc',
  brand_light    : '#367cba',
  brand_medium   : '#36475e',
  brand_alt_dark : '#3d4d61',
  brand_dark     : '#2d3d50',

  green_light    : '#5edb8b',
  green_dark     : '#5BC17F',

  seafoam_light  : '#51ccae',
  seaform_dark   : '#27a384',

  purple_light   : '#a45fbe',
  purple_dark    : '#9b4cb7',

  orange_light   : '#edc802',
  yellow         : '#edc802',
  orange_dark    : '#ef9d00',

  red_light      : '#cf5100',
  red_dark       : '#bc3129',

  blue_light     : '#ecf4fb',
  blue_medium    : '#669bc8',


  button_grey    : '#9B9C9E',
  button_shadow  : '#7F7F7F',
};



// WEBPACK FOOTER //
// ./src/app/lib/Style.js